module.exports = __webpack_public_path__ + "img/Group 25.487421a3.svg";